import type { CSSProperties } from "react";

export type ScoreLevel =
  | "None"
  | "Low"
  | "Clean"
  | "Medium"
  | "High"
  | "Flagged"
  | "Processing"
  | string;

interface ScoreColorConfig {
  color: string;
  bgColor: string;
  label: string;
}

const SCORE_COLORS: Record<string, ScoreColorConfig> = {
  None: { color: "#008000", bgColor: "#e6ffe6", label: "Clean" },
  Low: { color: "#008000", bgColor: "#e6ffe6", label: "Low" },
  Clean: { color: "#008000", bgColor: "#e6ffe6", label: "Clean" },
  Medium: { color: "#FF8C00", bgColor: "#fff3e0", label: "Medium" },
  High: { color: "#FF0000", bgColor: "#ffe6e6", label: "High" },
  Flagged: { color: "#FF0000", bgColor: "#ffe6e6", label: "Flagged" },
  Processing: { color: "#0e75c2", bgColor: "#e3f2fd", label: "Processing" },
};

const DEFAULT_CONFIG: ScoreColorConfig = {
  color: "#6c757d",
  bgColor: "transparent",
  label: "",
};

export function getScoreConfig(
  value: string | null | undefined
): ScoreColorConfig {
  if (!value) return DEFAULT_CONFIG;
  return SCORE_COLORS[value] ?? DEFAULT_CONFIG;
}

export function getScoreStyle(
  value: string | null | undefined
): CSSProperties {
  const config = getScoreConfig(value);
  return { color: config.color, fontWeight: 600 };
}

export function getScoreClassName(value: string | null | undefined): string {
  if (!value) return "";
  const normalized = value.toLowerCase();
  if (["none", "low", "clean"].includes(normalized)) return "score-clean";
  if (["high", "flagged"].includes(normalized)) return "score-high";
  if (normalized === "medium") return "score-medium";
  if (normalized === "processing") return "score-processing";
  return "";
}
